<template>
  <v-app>
    <div class="succ">
      <div class="succ-content">
        <svg-icon icon="img-success" class="succ-featured" width="860" height="300" />
        <h1 class="succ-heading">{{ content.title }}</h1>
        <div class="succ-content mb-8">{{ content.subtitle }}</div>
        <v-btn color="primary btn-primary-custom" width="260" @click="back()">{{ $t('success.back') }}</v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
import socketChat from '@/plugins/socketChat';
export default {
  name: 'Success',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    content() {
      let title;
      let subtitle;
      let url;
      let id;

      switch (this.type) {
        case 'school':
          title = this.$t('success.add_school_title');
          subtitle = this.$t('success.add_school_content');
          url = 'SchoolIndex';
          break;
        case 'school-update':
          title = this.$t('success.update_school_title');
          subtitle = this.$t('success.update_school_content');
          url = 'SchoolIndex';
          break;
        case 'schoolv1-update':
          title = this.$t('success.update_schoolv1_title');
          subtitle = this.$t('success.update_schoolv1_content');
          url = 'SchoolV1Index';
          break;
        case 'teacher':
          title = this.$t('success.add_teacher_title');
          subtitle = this.$t('success.add_teacher_content');
          url = 'TeacherIndex';
          break;
        case 'teacher-update':
          title = this.$t('success.update_teacher_title');
          subtitle = this.$t('success.update_teacher_content');
          url = 'TeacherIndex';
          break;
        case 'useradmin':
          title = this.$t('success.add_user_title');
          subtitle = this.$t('success.add_user_content');
          url = 'MasterUser';
          break;
        case 'user-update':
          title = this.$t('success.update_user_title');
          subtitle = this.$t('success.update_user_content');
          url = 'MasterUser';
          break;
        case 'user-lite-update':
          title = this.$t('success.update_user_title');
          subtitle = this.$t('success.update_user_content');
          url = 'MasterUserLite';
          break;
        case 'user-profile-update':
          title = this.$t('success.update_user_title');
          subtitle = this.$t('success.update_user_content');
          url = 'Profile';
          break;
        case 'change-child':
          title = this.$t('success.change_parent_title');
          subtitle = this.$t('success.change_parent_content');
          url = 'ParentCourseIndex';
          break;
        case 'userschool':
          title = this.$t('success.add_user_title');
          subtitle = this.$t('success.add_user_content');
          url = 'MasterUserSchool';
          break;
        case 'userschool-update':
          title = this.$t('success.update_user_title');
          subtitle = this.$t('success.update_user_content');
          url = 'MasterUserSchool';
          break;
        case 'update-permission':
          title = this.$t('success.update_permission_title');
          subtitle = this.$t('success.update_permission_content');
          url = 'Role';
          break;
        case 'update-permission-lite':
          title = this.$t('success.update_permission_title');
          subtitle = this.$t('success.update_permission_content');
          url = 'RoleLite';
          break;
        case 'student-school':
          title = this.$t('success.add_student_title');
          subtitle = this.$t('success.add_student_content');
          url = 'StudentIndex';
          break;
        case 'student-school-update':
          title = this.$t('success.update_student_title');
          subtitle = this.$t('success.update_student_content');
          url = 'StudentIndex';
          break;
        case 'course':
          title = this.$t('success.add_course_title');
          subtitle = this.$t('success.add_course__content');
          url = 'CourseIndex';
          break;
        case 'course-update':
          title = this.$t('success.update_course__title');
          subtitle = this.$t('success.update_course__content');
          url = 'CourseIndex';
          break;
        case 'class-level':
          title = this.$t('success.add_class_level');
          subtitle = this.$t('success.add_class_level_content');
          url = 'ClassLevelIndex';
          break;
        case 'class-level-update':
          title = this.$t('success.update_class_level');
          subtitle = this.$t('success.update_class_level_content');
          url = 'ClassLevelIndex';
          break;
        case 'school-class':
          title = this.$t('success.add_class');
          subtitle = this.$t('success.add_class_content');
          url = 'SchoolClassIndex';
          break;
        case 'school-class-update':
          title = this.$t('success.update_class');
          subtitle = this.$t('success.update_class_content');
          url = 'SchoolClassIndex';
          break;
        case 'accel-class':
          title = this.$t('success.add_class_accel');
          subtitle = this.$t('success.add_class_accel_content');
          url = 'ClassAccelIndex';
          break;
        case 'accel-class-update':
          title = this.$t('success.update_class_accel');
          subtitle = this.$t('success.update_class_accel_content');
          url = 'ClassAccelIndex';
          break;
        case 'group':
          title = this.$t('success.add_group');
          subtitle = this.$t('success.add_group_content');
          url = 'EnrollStudentIndex';
          break;
        case 'group-update':
          title = this.$t('success.update_group');
          subtitle = this.$t('success.update_group_content');
          url = 'EnrollStudentIndex';
          break;
        case 'quiz-teacher':
          title = this.$t('success.add_quiz');
          subtitle = this.$t('success.add_quiz_content');
          url = 'QuizTeacherIndex';
          break;
        case 'quiz-teacher-update':
          title = this.$t('success.update_quiz');
          subtitle = this.$t('success.update_quiz_content');
          url = 'QuizTeacherIndex';
          break;
        case 'quiz-teacher-class':
          title = this.$t('success.add_quiz');
          subtitle = this.$t('success.add_quiz_content');
          url = 'QuizTeacherIndexClass';
          break;
        case 'quiz-teacher-update-class':
          title = this.$t('success.update_quiz');
          subtitle = this.$t('success.update_quiz_content');
          url = 'QuizTeacherIndexClass';
          break;
        case 'quiz-teacher-section-class':
          title = this.$t('success.add_quiz');
          subtitle = this.$t('success.add_quiz_content');
          url = 'QuizTeacherSectionIndexClass';
          break;
        case 'quiz-teacher-section-update-class':
          title = this.$t('success.update_quiz');
          subtitle = this.$t('success.update_quiz_content');
          url = 'QuizTeacherSectionIndexClass';
          break;
        case 'attendance-teacher':
          title = this.$t('success.add_attendance');
          subtitle = this.$t('success.add_attendance_content');
          url = 'TeacherAttendanceIndex';
          break;
        case 'attendance-teacher-update':
          title = this.$t('success.update_attendance');
          subtitle = this.$t('success.update_attendance_content');
          url = 'TeacherAttendanceIndex';
          break;
        case 'attendance-section-teacher':
          title = this.$t('success.add_attendance');
          subtitle = this.$t('success.add_attendance_content');
          url = 'TeacherAttendanceSectionIndex';
          break;
        case 'attendance-section-teacher-update':
          title = this.$t('success.update_attendance');
          subtitle = this.$t('success.update_attendance_content');
          url = 'TeacherAttendanceSectionIndex';
          break;
        case 'grup-assign-teacher':
          title = this.$t('success.add_grup_assignment');
          subtitle = this.$t('success.add_grup_assignment_content');
          url = 'TeacherAssignment';
          break;
        case 'grup-assign-teacher-update':
          title = this.$t('success.update_grup_assignment');
          subtitle = this.$t('success.update_grup_assignment_content');
          url = 'TeacherAssignment';
          break;
        case 'assign-teacher':
          title = this.$t('success.add_assignment');
          subtitle = this.$t('success.add_assignment_content');
          url = 'TeacherAssignment';
          break;
        case 'assign-update-teacher':
          title = this.$t('success.update_assignment');
          subtitle = this.$t('success.update_assignment_content');
          url = 'TeacherAssignment';
          break;
        case 'assign-section-teacher':
          title = this.$t('success.add_assignment');
          subtitle = this.$t('success.add_assignment_content');
          url = 'TeacherAssignmentSection';
          break;
        case 'assign-update-section-teacher':
          title = this.$t('success.update_assignment');
          subtitle = this.$t('success.update_assignment_content');
          url = 'TeacherAssignmentSection';
          break;
        case 'assign-teacher-grading':
          title = this.$t('success.add_assignment_grading');
          subtitle = this.$t('success.add_assignment_content_grading');
          url = 'TeacherAssignmentDetail';
          break;
        case 'assign-teacher-section-grading':
          title = this.$t('success.add_assignment_grading');
          subtitle = this.$t('success.add_assignment_content_grading');
          url = 'TeacherAssignmentSectionDetail';
          break;
        case 'assign-teacher-score-file':
          title = this.$t('success.add_assignment_score_file');
          subtitle = this.$t('success.add_assignment_content_score_file');
          url = 'TeacherAssignmentDetail';
          break;
        case 'assign-student-quiz':
          title = this.$t('success.add_assignment_quiz_student');
          subtitle = this.$t('success.add_assignment_content_quiz_student');
          url = 'StudentAssignmentDetail';
          break;
        case 'assign-student-quiz-modules':
          title = this.$t('success.add_assignment_quiz_student');
          subtitle = this.$t('success.add_assignment_content_quiz_student');
          url = 'ModulesStudentIndexClass';
          break;
        case 'assign-section-student-quiz':
          title = this.$t('success.add_assignment_quiz_student');
          subtitle = this.$t('success.add_assignment_content_quiz_student');
          url = 'StudentSectionAssignmentDetail';
          break;
        case 'assign-section-student-quiz-modules':
          title = this.$t('success.add_assignment_quiz_student');
          subtitle = this.$t('success.add_assignment_content_quiz_student');
          url = 'ModulesStudentSectionIndexClass';
          break;
        case 'syllabus-teacher':
          title = this.$t('success.add_syllabus_title');
          subtitle = this.$t('success.add_syllabus_content');
          url = 'SyllabusIndex';
          break;
        case 'syllabus-teacher-update':
          title = this.$t('success.update_syllabus_title');
          subtitle = this.$t('success.update_syllabus_content');
          url = 'SyllabusIndex';
          break;
        case 'pages-teacher':
          title = this.$t('success.add_pages_title');
          subtitle = this.$t('success.add_pages_content');
          url = 'PagesIndexClass';
          break;
        case 'pages-teacher-update':
          title = this.$t('success.update_pages_title');
          subtitle = this.$t('success.update_pages_content');
          url = 'PagesIndexClass';
          break;
        case 'pages-teacher-section':
          title = this.$t('success.add_pages_title');
          subtitle = this.$t('success.add_pages_content');
          url = 'PagesSectionIndexClass';
          break;
        case 'pages-teacher-section-update':
          title = this.$t('success.update_pages_title');
          subtitle = this.$t('success.update_pages_content');
          url = 'PagesSectionIndexClass';
          break;
        case 'announcement-teacher':
          title = this.$t('success.add_announcement_title');
          subtitle = this.$t('success.add_announcement_content');
          url = 'AnnouncementIndexClass';
          break;
        case 'announcement-teacher-update':
          title = this.$t('success.update_announcement_title');
          subtitle = this.$t('success.update_announcement_content');
          url = 'AnnouncementIndexClass';
          break;
        case 'announcement-teacher-section':
          title = this.$t('success.add_announcement_title');
          subtitle = this.$t('success.add_announcement_content');
          url = 'AnnouncementSectionIndexClass';
          break;
        case 'announcement-teacher-section-update':
          title = this.$t('success.update_announcement_title');
          subtitle = this.$t('success.update_announcement_content');
          url = 'AnnouncementSectionIndexClass';
          break;
        case 'modules-teacher':
          title = this.$t('success.add_modules_title');
          subtitle = this.$t('success.add_modules_content');
          url = 'ModulesIndexClass';
          break;
        case 'modules-teacher-update':
          title = this.$t('success.update_modules_title');
          subtitle = this.$t('success.update_modules_content');
          url = 'ModulesIndexClass';
          break;
        case 'modules-teacher-section':
          title = this.$t('success.add_modules_title');
          subtitle = this.$t('success.add_modules_content');
          url = 'ModulesSectionIndexClass';
          break;
        case 'modules-teacher-section-update':
          title = this.$t('success.update_modules_title');
          subtitle = this.$t('success.update_modules_content');
          url = 'ModulesSectionIndexClass';
          break;
        case 'discussion-teacher':
          title = this.$t('success.add_discussion_title');
          subtitle = this.$t('success.add_discussion_content');
          url = 'DiscussionIndexClass';
          break;
        case 'discussion-teacher-update':
          title = this.$t('success.update_discussion_title');
          subtitle = this.$t('success.update_discussion_content');
          url = 'DiscussionIndexClass';
          break;
        case 'discussion-teacher-section':
          title = this.$t('success.add_discussion_title');
          subtitle = this.$t('success.add_discussion_content');
          url = 'DiscussionSectionIndexClass';
          break;
        case 'discussion-teacher-section-update':
          title = this.$t('success.update_discussion_title');
          subtitle = this.$t('success.update_discussion_content');
          url = 'DiscussionSectionIndexClass';
          break;
        case 'erapor-template-teacher':
          title = this.$t('success.add_erapor_template_title');
          subtitle = this.$t('success.add_erapor_template_content');
          url = 'eRaporTemplateIndex';
          break;
        case 'erapor-template-teacher-update':
          title = this.$t('success.update_erapor_template_title');
          subtitle = this.$t('success.update_erapor_template_content');
          url = 'eRaporTemplateIndex';
          break;
        case 'erapor-template-schooladmin':
          title = this.$t('success.add_erapor_template_title');
          subtitle = this.$t('success.add_erapor_template_content');
          url = 'eRaporTemplateSchoolAdminIndex';
          break;
        case 'erapor-template-schooladmin-update':
          title = this.$t('success.update_erapor_template_title');
          subtitle = this.$t('success.update_erapor_template_content');
          url = 'eRaporTemplateSchoolAdminIndex';
          break;
        case 'erapor-integ-teacher':
          title = this.$t('success.add_erapor_integ_title');
          subtitle = this.$t('success.add_erapor_integ_content');
          url = 'eRaporGeneratorIndex';
          break;
        case 'erapor-integ-teacher-update':
          title = this.$t('success.update_erapor_integ_title');
          subtitle = this.$t('success.update_erapor_integ_content');
          url = 'eRaporGeneratorIndex';
          break;
        case 'erapor-generator-teacher':
          title = this.$t('success.update_erapor_generator_title');
          subtitle = this.$t('success.update_erapor_generator_content');
          url = 'eRaporGeneratorView';
          break;
        case 'category-teacher':
          title = this.$t('success.add_category_title');
          subtitle = this.$t('success.add_category_content');
          url = 'AnalyticTeacherListID';
          id = 1;
          break;
        case 'category-teacher-teacher':
          title = this.$t('success.update_category_title');
          subtitle = this.$t('success.update_category_content');
          url = 'AnalyticTeacherListID';
          id = 1;
          break;
        case 'category-student':
          title = this.$t('success.add_category_title');
          subtitle = this.$t('success.add_category_content');
          url = 'AnalyticStudentListID';
          id = 1;
          break;
        case 'category-student-teacher':
          title = this.$t('success.update_category_title');
          subtitle = this.$t('success.update_category_content');
          url = 'AnalyticStudentListID';
          id = 1;
          break;
        case 'template-teacher':
          title = this.$t('success.add_category_title');
          subtitle = this.$t('success.add_category_content');
          url = 'AnalyticTeacherListID';
          id = 2;
          break;
        case 'template-teacher-teacher':
          title = this.$t('success.update_template_title');
          subtitle = this.$t('success.update_template_content');
          url = 'AnalyticTeacherListID';
          id = 2;
          break;
        case 'use-template-teacher':
          title = this.$t('success.add_use_template_title');
          subtitle = this.$t('success.add_use_template_content');
          url = 'AnalyticTeacherListID';
          id = 2;
          localStorage.setItem('currentIdQuizMenu', 1);
          break;
        case 'template-student':
          title = this.$t('success.add_category_title');
          subtitle = this.$t('success.add_category_content');
          url = 'AnalyticStudentListID';
          id = 4;
          break;
        case 'template-teacher-student':
          title = this.$t('success.update_template_title');
          subtitle = this.$t('success.update_template_content');
          url = 'AnalyticStudentListID';
          id = 4;
          break;
        case 'use-template-student':
          title = this.$t('success.add_use_template_title');
          subtitle = this.$t('success.add_use_template_content');
          url = 'AnalyticStudentListID';
          id = 5;
          break;
        case 'success-deactivate-user':
          title = this.$t('success.deactivate_user');
          subtitle = this.$t('success.deactivate_user_message');
          url = 'AuthLogin';
          this.logout();
          break;
        case 'parent-add-student-school':
          title = this.$t('success.add_student_title');
          subtitle = this.$t('success.add_student_content');
          url = 'EditParent';
          id = this.$route.params.id;
          break;
        case 'parent-edit-student-school':
          title = this.$t('success.update_student_title');
          subtitle = this.$t('success.update_student_content');
          url = 'EditParent';
          id = this.$route.params.id;
          break;
        case 'parent-student-edit':
          title = this.$t('success.update_parent-student_title');
          subtitle = this.$t('success.update_parent-student_content');
          url = 'ParentIndex';
          break;
      }
      return { title, subtitle, url, id };
    }
  },
  methods: {
    back() {
      localStorage.removeItem('timeQuiz');
      this.$router.push({
        name: this.content.url,
        params: this.content.id ? { idSidebar: this.content.id } : ''
      });
    },
    logout() {
      this.$store.dispatch('Auth/logout').then(() => {
        localStorage.clear();

        const token = 'ask_your_tech_lead';
        socketChat.auth = { token, userId: this.user.userId, username: this.user.fullName };
        socketChat.connect();

        socketChat.disconnect();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 24px;
  }

  @include query-min-sm() {
    &-featured {
      width: auto;
      height: 340px;
    }
  }
}
</style>
